/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, July 8th 2022, 9:25:14 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import { StandardTagInfo } from "lib/schemas";
import { ContextTagButton } from "./ContextTagButton";

interface StandardTagsInfoComponentProps
  extends Pick<React.ComponentProps<typeof ContextTagButton>, "onCopyContextTag" | "copiedMessage"> {
  tagsInfo: StandardTagInfo[];
  tagButtonIcon: React.ReactNode;
}

export const StandardTagsInfoComponent = (props: StandardTagsInfoComponentProps) => (
  <Grid container spacing={2} sx={{ padding: 5 }}>
    {props.tagsInfo?.map((tagInfo) => {
      return (
        <Grid key={`${tagInfo.tag_name}`} item xs={4}>
          <ContextTagButton
            onCopyContextTag={props.onCopyContextTag}
            copiedMessage={props.copiedMessage}
            tagName={tagInfo.tag_name}
            tag={tagInfo.tag}
            iconComponent={props.tagButtonIcon}
          />
        </Grid>
      );
    })}
  </Grid>
);
